import React from 'react';
import { useTranslation } from '../../i18n';
import { formatMoney } from '../../utils/format';

export function MonthlyKpis({ monthlyRevenues, monthlyExpenses }) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="surface-card p-3.5">
        <p className="overline">{t('monthly_revenue')}</p>
        <p className="data-stat text-lg font-bold text-money mt-1.5">{formatMoney(monthlyRevenues)}</p>
      </div>
      <div className="surface-card p-3.5">
        <p className="overline">{t('monthly_expenses')}</p>
        <p className="data-stat text-lg font-bold text-danger mt-1.5">{formatMoney(monthlyExpenses)}</p>
      </div>
    </div>
  );
}
